import { Component, ChangeDetectionStrategy, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  template: `
    <nav class="px-0 navbar navbar-expand-lg navbar-dark bg-dark shadow-sm">
      <!-- Añadimos 'justify-content-between' para forzar extremos opuestos en pantallas pequeñas -->
      <div class="px-1 container justify-content-between">
      <div class="d-flex container justify-content-between">
        
        <!-- 1. Marca / Logo (A la izquierda) -->
        <a class="navbar-brand" routerLink="/" (click)="closeMenu()">MiApp</a>

        <!-- 2. Botón Hamburguesa (A la derecha) -->
        <button 
          class="navbar-toggler" 
          type="button"
          (click)="toggleMenu()" 
          [attr.aria-expanded]="isMenuOpen()" 
          aria-label="Alternar navegación">
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>

        <!-- 3. Contenido colapsable (Menú de navegación) -->
        <div class="collapse navbar-collapse flex-grow-0" [class.show]="isMenuOpen()">
          <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <a 
                class="nav-link"
                routerLink="/" 
                routerLinkActive="active" 
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="closeMenu()">
                Inicio
              </a>
            </li>
            <li class="nav-item">
              <a 
                class="nav-link"
                routerLink="/land" 
                routerLinkActive="active" 
                (click)="closeMenu()">
                Servicios
              </a>
            </li>
            <li class="nav-item">
              <a 
                class="nav-link"
                routerLink="/acerca" 
                routerLinkActive="active" 
                (click)="closeMenu()">
                Contacto
              </a>
            </li>
            <li class="nav-item">
              <a 
                class="nav-link"
                routerLink="/documentos" 
                routerLinkActive="active" 
                (click)="closeMenu()">
                Documentos
              </a>
            </li>
          </ul>
        </div>
        
      </div>
    </nav>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Navbar {
  readonly isMenuOpen = signal(false);

  toggleMenu(): void {
    this.isMenuOpen.update((isOpen) => !isOpen);
  }

  closeMenu(): void {
    this.isMenuOpen.set(false);
  }
}